/**
 * 撮影の流れ（Issue #692。設計 docs/live-match-flow.md）の画面用の小さな関数。状態と撮影予定の列はサーバー（GetLiveMatch）が持つ。
 */
export const STATE_LABELS = {
  idle: '対戦アイドル（P1 の席で撮影する試合を選ぶ）',
  ready: '対戦待機中（録画開始を待っています）',
  playing: '対戦中',
  finished: '対戦終了（後処理）',
};
export const MODE_LABELS = { local: '同席（OBS で録画）', remote: 'リモート（各自の TetherCam で録画）' };

/** 列の 1 件 → 「決闘 1 本目」 */
export function gameLabel(item) {
  return [item?.duel_name, item?.game_name].filter(Boolean).join(' ') || item?.game_uuid || '';
}

/** 列（GetLiveMatch の schedule）→ SetLiveSchedule の items */
export function toItems(schedule) {
  return (schedule ?? []).map((s) => ({ game_uuid: s.game_uuid, mode: s.mode }));
}

/** 末尾に足す。撮り方の既定は前の試合と同じ（無ければ同席）。もう入っていれば足さない */
export function addItem(items, gameUuid) {
  if (items.some((i) => i.game_uuid === gameUuid)) return items;
  const mode = items.length ? items[items.length - 1].mode : 'local';
  return [...items, { game_uuid: gameUuid, mode }];
}

/** i 番目を delta だけ動かす（端は止まる） */
export function moveItem(items, i, delta) {
  const j = i + delta;
  if (j < 0 || j >= items.length) return items;
  const out = [...items];
  [out[i], out[j]] = [out[j], out[i]];
  return out;
}

/** 状態の一行（録画・決着・録画落ち） */
export function matchSummary(m) {
  if (!m) return '';
  const parts = [STATE_LABELS[m.state] ?? m.state];
  if (m.game) parts.push(gameLabel(m.game));
  if (m.mode) parts.push(MODE_LABELS[m.mode]);
  const recs = Object.entries(m.recordings ?? {});
  if (recs.length) parts.push(`録画: ${recs.map(([src, r]) => `${src} ${r.stopped ? '停止' : r.started ? '録画中' : '—'}`).join(' / ')}`);
  if (m.decided) parts.push('決着（録画を停止してください）');
  return parts.join('・');
}

/** 今の対戦の試合に入る入力画面の URL（Issue #744）。game（duel_id）と game_uuid があるときだけ。P1 / P2 の席と観客 */
export function joinLinks(m) {
  if (!m?.game?.duel_id || !m.game_uuid || !['ready', 'playing', 'finished'].includes(m.state)) return [];
  const base = `/duels/${m.game.duel_id}/game/${m.game_uuid}/input`;
  return [
    { key: 'seat1', label: 'P1 として参加', to: `${base}?seat=1&live=1` },
    { key: 'seat2', label: 'P2 として参加', to: `${base}?seat=2&live=1` },
    { key: 'watch', label: '観客として参加', to: `${base}?watch=1&live=1` },
  ];
}

/**
 * 入力画面が追う録画の鍵（Issue #744 / #803）。この試合（gameUuid）が対戦待機中・対戦中のときだけ。
 * 席によらず本番が選んだ試合の時計の録画（GetLiveMatch の clock）。補正サーバーはどの鍵でも同じ合成の映像で、違うのは時刻の基準だけ
 * ＝答えの video_ms をどの端末でも同じ 0 秒から数えるため。始まっていなければ null
 */
export function liveRecordingKey(m, gameUuid) {
  if (!m || !gameUuid || m.game_uuid !== gameUuid || !['ready', 'playing'].includes(m.state)) return null;
  return m.clock?.key ?? null;
}
